import script from "./type_contract.vue?vue&type=script&setup=true&lang=js"
export * from "./type_contract.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__